import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { ConfigContext } from './ConfigContext';
import { getLightColorCode } from '@/utils/utilities';
import { useThemeDetails } from './ThemeDetailsContext';
const SuccessModal = ({ open, onClose, title, message, gif, buttonText, width = '500px', height = 'auto' }) => {
    const { configState } = React.useContext(ConfigContext);
    const { stateImages } = useThemeDetails();
    return (_jsxs(Dialog, { open: open, onClose: onClose, "aria-labelledby": "success-modal-title", "data-testid": "success-modal", PaperProps: {
            sx: {
                width: width,
                height: height,
                textAlign: 'center'
            }
        }, children: [_jsxs(DialogContent, { sx: { p: 0, px: 2, py: 3 }, children: [_jsx(Box, { sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            mb: 3
                        }, children: _jsx(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: `radial-gradient(71.14% 71.14% at 50% 50%, ${configState?.settings?.button_color} 0%, ${getLightColorCode(configState?.settings?.button_color, 0.5)} 100%)`,
                                borderRadius: '100%',
                                width: '78px',
                                height: '78px'
                            }, children: _jsx("img", { src: stateImages?.Success || gif, alt: "Success", width: 81, height: 81 }) }) }), _jsx(Typography, { id: "success-modal-title", variant: "h6", component: "h2", sx: {
                            mb: 2
                        }, children: title }), message] }), _jsx(DialogActions, { sx: { p: 0, px: 3, py: 2, justifyContent: 'center' }, children: _jsx(Button, { onClick: onClose, variant: "contained", color: "success", "data-testid": "success-modal-close-button", sx: {
                        background: configState?.settings?.button_color,
                        color: configState?.settings?.button_text_color,
                        textTransform: 'none',
                        fontSize: '16px'
                    }, children: _jsx(Typography, { variant: "h6", color: "#FFFFFF", fontWeight: 600, children: buttonText }) }) })] }));
};
export default SuccessModal;
